import { OrganizationInformation } from "@/types";
import { CoreFieldProps, fieldTypes, NumericFieldProps, SectionHeader } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import "./ComplexFields.scss";

export interface OrganizationInformationComplexValue {
  showHeader?: boolean;
  headerLabel?: string;
  isSoleProprietorship?: boolean;
}

export interface OrganizationInformationComplexFieldProps
  extends fieldTypes.BaseFieldProps<OrganizationInformation> {
  complexFieldValue?: OrganizationInformationComplexValue;
}

export const OrganizationInformationComplexField: FC<OrganizationInformationComplexFieldProps> = (
  props
) => {
  return (
    <section className="complex-field-container organization-information">
      <div className="complex-field-container__header">
        <SectionHeader label={props.complexFieldValue?.headerLabel || props.label} hidden={!props.complexFieldValue?.showHeader} />
      </div>
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.ORGANIZATION_INFORMATION.LEGAL_ORGANIZATION_NAME}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.ORGANIZATION_INFORMATION.FICTITIOUS_ORGANIZATION_NAME}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.ORGANIZATION_INFORMATION.ORGANIZATION_TYPE}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.ORGANIZATION_INFORMATION.EMPLOYER_IDENTIFICATION_NUMBER
          }
          complexFieldProps={
            {
              defaultToSensitiveHidden: false,
              isRequired: !props.complexFieldValue?.isSoleProprietorship,
            } as fieldTypes.EmployerIdentificationNumberProps
          }
        />
        {!props.complexFieldValue?.isSoleProprietorship && (
          <FieldComplexV2
            {...props}
            complexFieldKey={COMPLEX_FIELD_KEYS.ORGANIZATION_INFORMATION.STATE_OF_FORMATION}
            complexFieldProps={{
              isRequired: !props.complexFieldValue?.isSoleProprietorship,
            }}
          />
        )}
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.ORGANIZATION_INFORMATION.YEAR_ESTABLISHED}
          complexFieldProps={
            {
              showIncrementButtons: false,
              format: "n0",
              isRequired: !props.complexFieldValue?.isSoleProprietorship,
            } as NumericFieldProps
          }
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.ORGANIZATION_INFORMATION.ORGANIZATION_PHONE_NUMBER}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.ORGANIZATION_INFORMATION.ORGANIZATION_EMAIL_ADDRESS}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.ORGANIZATION_INFORMATION.ORGANIZATION_WEBSITE_URL}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.ORGANIZATION_INFORMATION.NAICS_CODE}
          complexFieldProps={
            {
              searchMethod: "contains",
            } as Partial<CoreFieldProps>
          }
        />
        {!props.complexFieldValue?.isSoleProprietorship && (
          <FieldComplexV2
            {...props}
            complexFieldKey={
              COMPLEX_FIELD_KEYS.ORGANIZATION_INFORMATION
                .ENTITY_OR_TRUST_HAS_25_PERCENT_OR_GREATER_OWNERSHIP_IN_ORGANIZATION
            }
            complexFieldProps={{
              isRequired: !props.complexFieldValue?.isSoleProprietorship,
              showClearButton: true,
            } as Partial<CoreFieldProps>}
          />
        )}
      </div>

      {/* {props.value?.entityOrTrustHas25PercentOrGreaterOwnershipInOrganization && (
        <div className="organization-information-banner">
          <div className="banner-content">
            <p>
              Thank you! A Best Bank concierge will be in contact with you to collect details
              regarding entity or trust beneficial ownership. Later on in the application process,
              we will collect information from you regarding non-entity or trust beneficial owners
              and authorized signers, as well as your organization's control person.
            </p>
          </div>
        </div>
      )} */}
    </section>
  );
};
